'use client';

import { LiveFeedStreamResponse } from '@/types/feed';
import { useFetch } from '@spikemark/shared-hooks';
import { Feed } from '@spikemark/ui/components/feed/feed';
import { LoadingSpinner } from '@spikemark/ui/components/loading-spinner';
import { FC } from 'react';
type LiveCompactFeedProps = {
  tournamentId?: number;
};
export const LiveCompactFeed: FC<LiveCompactFeedProps> = ({
  tournamentId
}) => {
  const {
    data,
    isLoading
  } = useFetch<LiveFeedStreamResponse>(`/api/feed/entries/${tournamentId}/compact`, 'GET');
  if (isLoading) {
    return <LoadingSpinner />;
  }
  return <Feed data={data ? data.entries ?? [] : []} variant="compact" isAggregated data-sentry-element="Feed" data-sentry-component="LiveCompactFeed" data-sentry-source-file="live-compact-feed.tsx" />;
};